import { render, staticRenderFns } from "./IntegralRuleView.vue?vue&type=template&id=22c4cb2e&scoped=true&"
import script from "./IntegralRuleView.vue?vue&type=script&lang=js&"
export * from "./IntegralRuleView.vue?vue&type=script&lang=js&"
import style0 from "./IntegralRuleView.vue?vue&type=style&index=0&id=22c4cb2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4cb2e",
  null
  
)

export default component.exports